class CollectionLoadMore extends HTMLElement {
	constructor() {
		super();
		const container = this.querySelector('#ProductGridContainer');
		window.isSayeLoading = false;

		function loading() {
			const rect = container.getBoundingClientRect();
			if (rect.top * -1 + window.innerHeight * 1 > rect.height / 2) {
				if (window.isSayeLoading == false) {
					window.isSayeLoading = true;
					const next = container.querySelector('.pagination__item--prev');
					if (next != null) {
						let url = next.getAttribute('href').split('?');
						const queryOptions = { method: 'GET', credentials: 'same-origin' };
						const queries = [fetch(url[0] + '?view=ajax&' + url[1], queryOptions)];

						Promise.all(queries).then(function (responses) {
							Promise.all(
								responses.map(function (response) {
									return response.text();
								}),
							)
								.then(function (contents) {
									if (window.isSayeLoading == true) {
										let element = document.createElement('ul');
										element.innerHTML = contents[0];
										const pagination = element.querySelector('.pagination');
										if (
											pagination.querySelector('.pagination__item--prev') ==
											null
										) {
											container.querySelector('.pagination').remove();
										} else {
											container.querySelector('.pagination').innerHTML =
												pagination.innerHTML;
										}
										element.querySelectorAll('.grid__item').forEach((el) => {
											container
												.querySelector('#product-grid')
												.appendChild(el);
										});
										document.body.dispatchEvent(
											new CustomEvent('collection:update'),
										);
										window.isSayeLoading = false;
										loading();
									}
								})
								.catch(function () {
									window.isSayeLoading = false;
								});
						});
					} else {
						window.isSayeLoading = false;
					}
				}
			}
		}

		document.addEventListener('scroll', () => {
			loading();
		});
	}
}

customElements.define('collection-load-more', CollectionLoadMore);
